import React from "react";

export type SpaceProps = {
  size?: number;
};

const VerticalSpaceComponent = (props: SpaceProps): JSX.Element => (
  <div style={{ height: props.size }} />
);

export const VerticalSpace = React.memo(VerticalSpaceComponent);
